
import {Component, Vue, Watch} from "vue-property-decorator";
import {Getter} from "vuex-class";

import NewsTicker from "../features/NewsTicker.vue";
import AppBottomNavBar from "../ui/AppBottomNavBar.vue";
import {Route} from "vue-router";
import DeviceType from "../../utils/DeviceUtil";
import { mixins } from "vue-class-component";

@Component({
    components: {
        NewsTicker,
        AppBottomNavBar
    }
})
export default class AppFooter extends mixins(DeviceType) {
    @Getter("isAuthenticated") private isAuthurized!: boolean;
    private showNewsTicker = true;

    created() {
        if (this.$route.name === "Login" || this.$route.name === "Reset Password") {
            this.showNewsTicker = false;
        }
    }

    @Watch("$route")
    isAllowedRoute(val: Route) {
        if (val.name === "Home") {
            this.showNewsTicker = true;
        } else if((val.name === "Booths"  && !(this.isMobile || this.isTablet))) {
            this.showNewsTicker = true;
        } else {
            this.showNewsTicker = false;
        }
    }
}
